import { render, staticRenderFns } from "./modalSignup.vue?vue&type=template&id=b2b41a94&scoped=true"
import script from "./modalSignup.vue?vue&type=script&lang=js"
export * from "./modalSignup.vue?vue&type=script&lang=js"
import style0 from "./modalSignup.vue?vue&type=style&index=0&id=b2b41a94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b41a94",
  null
  
)

export default component.exports